import Typography from "@mui/material/Typography";
import { withStyles } from "tss-react/mui";

export const ZoneTypography = withStyles(Typography, {
  root: {
    fontWeight: "bold",
    fontSize: "0.75rem",
  },
});

export const ZoneSubTypography = withStyles(Typography, {
  root: {
    fontSize: "0.75rem",
  },
});

